const modals = new Map()

const getScrollbarWidth = () => {
	if (!document.body) return 0
	return window.innerWidth - document.body.offsetWidth
}

const setScrollbarCompensation = width => {
	const root = document.documentElement
	if (width > 0) {
		root.style.setProperty("--scrollbar-width", `${width}px`)
	} else {
		root.style.removeProperty("--scrollbar-width")
	}
}

export const closeAllModals = () => {
	document.querySelectorAll(".modal-overlay.show").forEach(modal => {
		modal.classList.remove("show")
	})
	document.body.classList.remove("stop-scroll")
	setScrollbarCompensation(0)
}

export const openModal = modal => {
	closeAllModals()

	setScrollbarCompensation(getScrollbarWidth())
	document.body.classList.add("stop-scroll")
	modal?.classList.add("show")
}

export const closeModal = (modal, unlockScroll = true) => {
	modal?.classList.remove("show")

	if (!unlockScroll) return
	const openedModal = document.querySelector(".modal-overlay.show")
	if (openedModal) return

	setTimeout(() => {
		document.body.classList.remove("stop-scroll")
		setScrollbarCompensation(0)
	}, 300)
}

function initModals() {
	document.querySelectorAll("[data-modal]")?.forEach(modal => {
		const closeBtns = modal.querySelectorAll(".modal-close-btn")
		const modalCloseBtns = modal.querySelectorAll("[data-modal-close]")
		const modalContent = modal.querySelector(".modal")

		modal.addEventListener("mousedown", () => closeModal(modal))
		modalContent.addEventListener("mousedown", e => e.stopPropagation())

		closeBtns?.forEach(btn => btn.addEventListener("click", () => closeModal(modal)))
		modalCloseBtns?.forEach(btn => btn.addEventListener("click", () => closeModal(modal)))
		modals.set(modal.dataset.modal, modal)
	})
}

document.addEventListener("click", e => {
	const btn = e.target.closest("[data-call-modal]")
	if (!btn) return

	const modal = modals.get(btn.dataset.callModal)
	if (!modal) return

	if (btn.dataset.callModal === "search" && modal) {
		if (modal.classList.contains("show")) {
			closeModal(modal)
			return
		}
	}

	if (btn.dataset.callModal === "menu" && modal) {
		if (modal.classList.contains("show")) {
			closeModal(modal)
			return
		}
	}

	if (btn.dataset.callModal === "catalog" && modal) {
		if (modal.classList.contains("show")) {
			closeModal(modal)
			return
		}
	}

	if (btn.dataset.callModal === "find-price" && modal) {
		const productNameEl = modal.querySelector(".find-price__product-name")
		const productImageEl = modal.querySelector(".find-price__product-image img")
		const form = modal.querySelector("form[data-action]")
		const productIdInput = form?.querySelector('input[name="productId"]')
		const productTitleInput = form?.querySelector('input[name="productTitle"]')

		let productId = btn.getAttribute("data-product-id") || ""
		let productTitle = btn.getAttribute("data-product-title") || ""
		let productImage = btn.getAttribute("data-product-image") || ""

		if (!productTitle) {
			const card = btn.closest(".product-card, .product-card-horizontal, .service-card-horizontal")
			if (card) {
				const titleEl = card.querySelector(".product-card__title, .product-card-horizontal__title, .service-card-horizontal__title")
				if (titleEl) productTitle = titleEl.textContent.trim()
			}
		}

		if (!productImage) {
			const card = btn.closest(".product-card, .product-card-horizontal, .service-card-horizontal")
			if (card) {
				const imgEl = card.querySelector(".product-card__image img, .product-card-horizontal__image img, .service-card-horizontal__image img")
				if (imgEl) productImage = imgEl.src || imgEl.getAttribute("src") || ""
			}
		}

		if (productNameEl) {
			productNameEl.textContent = productTitle || "Товар"
		}
		if (productImageEl && productImage) {
			productImageEl.src = productImage
			productImageEl.alt = productTitle || "Товар"
		}
		if (productIdInput) productIdInput.value = productId
		if (productTitleInput) productTitleInput.value = productTitle
	} else if (btn.dataset.callModal === "add-cart" && modal) {
		const productNameEl = modal.querySelector(".add-cart__product-name")
		const productImageEl = modal.querySelector(".add-cart__product-image img")

		let productTitle = btn.getAttribute("data-product-title")
		let productImage = btn.getAttribute("data-product-image")

		if (!productTitle || productTitle.trim() === "") {
			const card = btn.closest(".product-card, .product-card-horizontal, .service-card-horizontal")
			if (card) {
				const titleEl = card.querySelector(".product-card__title, .product-card-horizontal__title, .service-card-horizontal__title")
				if (titleEl) productTitle = titleEl.textContent.trim()
			}
			if (!productTitle || productTitle.trim() === "") {
				const productSection = btn.closest(".product")
				if (productSection) {
					const titleEl = productSection.querySelector(".product__title")
					if (titleEl) productTitle = titleEl.textContent.trim()
				}
			}
		}

		if (!productImage || productImage.trim() === "") {
			const card = btn.closest(".product-card, .product-card-horizontal, .service-card-horizontal")
			if (card) {
				const imgEl = card.querySelector(".product-card__image img, .product-card-horizontal__image img, .service-card-horizontal__image img")
				if (imgEl) {
					productImage = imgEl.src || imgEl.getAttribute("src") || imgEl.getAttribute("data-src") || ""
				}
			}
			if (!productImage || productImage.trim() === "") {
				const productSection = btn.closest(".product")
				if (productSection) {
					const imgEl = productSection.querySelector(".product__gallery .product__image img, .product__image img")
					if (imgEl) {
						productImage = imgEl.src || imgEl.getAttribute("src") || imgEl.getAttribute("data-src") || ""
					}
				}
			}
		}

		if (productNameEl) {
			productNameEl.textContent = productTitle || "Товар"
		}
		if (productImageEl && productImage) {
			productImageEl.src = productImage
			productImageEl.alt = productTitle || "Товар"
		}
	}
	openModal(modal)
})

initModals()

export const reinitModals = () => {
	initModals()
}

document.addEventListener("DOMContentLoaded", () => {
	document.addEventListener("ocfilter:updated", () => {
		reinitModals()
	})

	const listingContainer = document.querySelector(".listing__products-list")
	if (listingContainer) {
		let timeoutId = null
		const observer = new MutationObserver(() => {
			clearTimeout(timeoutId)
			timeoutId = setTimeout(() => {
				reinitModals()
			}, 100)
		})
		
		observer.observe(listingContainer, {
			childList: true,
			subtree: true
		})
	}
})

document.addEventListener("keydown", e => {
	if (e.key === "Escape" || e.code === "Escape") {
		const openedModal = document.querySelector(".modal-overlay.show")
		if (openedModal) closeModal(openedModal)
	}
})
